export interface Storage
{
	get(item : string, def : any) : any;
	set(item : string, value : any);
	unset(item : string);
	ready();
}

export class CookieStorage implements Storage
{
	constructor(private prefix : string)
	{
	}

	get(item:string, def:any) : any
	{
		let nameEQ = this.prefix + item + "=";
		let ca = document.cookie.split(';');

		for(let i=0;i < ca.length;i++) {
			let c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}

		return def;
	}

	set(item : string, value : any, days : number = 1000)
	{
		let date = new Date();
		date.setTime(date.getTime()+(days * 24 * 60 * 60 * 1000));
		let expires = "; expires=" + date.toUTCString();

		document.cookie = this.prefix + item + "=" + value.toString() + expires + "; path=/";
	}

	unset(item:string)
	{
		this.set(item, "", -1);
	}

	ready() {
	}
}

export class LocalStorage implements Storage
{
	static isSupported()
	{
		let mod = "sxc_ls_test_" + Date.now();

		try {
			localStorage["setItem"](mod, mod);
			localStorage["removeItem"](mod);
			return true;
		} catch(e) {
			return false;
		}
	}

	constructor(private prefix : string)
	{
	}

	get(item : string, def : any)
	{
		let res = localStorage["getItem"](this.prefix + item);

		if (res !== null) {
			try {
				res = JSON.parse(res)
			} catch (e) {
				res = def;
			}
		} else {
			res = def;
		}

		return res;
	}

	set(item : string, value : any)
	{
		localStorage["setItem"](this.prefix + item, JSON.stringify(value));
	}

	unset(item : string) {
		localStorage["removeItem"](this.prefix + item)
	}

	ready()
	{
		return true;
	}
}

export class LocalStorageWithCookies implements Storage
{
	storage : Storage;

	constructor(prefix : string)
	{
		this.storage = LocalStorage.isSupported()
			? new LocalStorage(prefix)
			: new CookieStorage(prefix);
	}


	get(item:string, def:any)
	{
		return this.storage.get(item, def);
	}

	set(item:string, value:any)
	{
		this.storage.set(item, value);
	}

	unset(item:string)
	{
		this.storage.unset(item);
	}

	ready()
	{
		return this.storage.ready();
	}
}
